<template>
    <div class="whole-div-PQI">
      <!--      第一行-->
      <div class="div1-PQI">
        <a class="div1-a1-PQI" @click="clickReturn"> < 返回</a><br>
      </div>
<!--      第二行-->
      <div class="div2-PQI">
        <div class="div2-div1-PQI">
          <a class="div2-a1-PQI">{{introduce.title}}</a><br>
          <a class="div2-a2-PQI">免责声明:内容来自互联网搜集,与本平台无关,如有侵权请联系平台管理员删除,我们不承担任何责任.&#12288;发布时间：{{introduce.dateTime}} </a>
        </div>
      </div>
<!--      第三行-->
      <div class="div2-PQI">
        <div class="div3-div1-PQI">
          {{introduce.details}}
        </div>
      </div>
    </div>
</template>

<script>
  import '../../css/pc/PQI_PcQuestionIntroduce.css'
    export default {
        name: "PcQuestionIntroduce",
      data(){
          return{
            introduce:{
              title:'病死猪',
              dateTime:'2024-04-10',
              details:'近年来，随着我国养殖业的大力发展，病死动物的处理对净化环境意义重大。病死动物干化机是病死动物无害化处理常用的主体设备。'
            },
          }
      },
      mounted(){
          this.introduce=this.$store.state.questionIntroduce;
      },
      methods:{
          clickReturn(){
            this.$router.go(-1);
          }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/computer/second/PcQuestionIntroduce.vue